
const About = {
  init() {
    this.events();
  },

  events() {

  },

};

export default About;
